import { getOrigin } from 'owa-url';
import { Version, ObjectType } from '../utils/restAPIConstants';
import HttpReadyState from 'owa-http-status-codes/lib/HttpReadyState';
import HttpStatusCode from 'owa-http-status-codes/lib/HttpStatusCode';
import { HttpConstants } from '../utils/httpConstants';
import type AddMembersRestRequest from '../schema/AddMembersRestRequest';
import type AddMembersRestResponse from '../schema/AddMembersRestResponse';

export default async function addMembersRest(
    accessToken: string,
    AddMembersRequest: AddMembersRestRequest,
    groupId: string,
    tenantId: string,
    rwcToken?: string
): Promise<AddMembersRestResponse> {
    if (!accessToken) {
        return {
            Success: false,
            ErrorMessage: 'Access token is null or empty',
        };
    }

    return new Promise<AddMembersRestResponse>((resolve, reject) => {
        const externalObjectId = groupId + '@' + tenantId;
        const url = getOrigin() + Version.V2 + ObjectType.Groups + groupId + ObjectType.AddMembers;
        const request = new XMLHttpRequest();
        request.open(HttpConstants.Post, url, true);
        request.setRequestHeader(
            HttpConstants.AuthorizationTag,
            HttpConstants.BearerTokenHeader + accessToken
        );
        request.setRequestHeader(
            HttpConstants.PreferTag,
            HttpConstants.PreferValueExchangeBehaviorTag +
                '="' +
                HttpConstants.PreferValueGroupMembers +
                '"'
        );
        request.setRequestHeader(
            HttpConstants.XAnchorMailbox,
            HttpConstants.OIDPrefix + externalObjectId
        );
        request.setRequestHeader(HttpConstants.ContentTypeHeader, HttpConstants.ContentTypeValue);
        if (rwcToken && rwcToken.length > 0) {
            request.setRequestHeader(HttpConstants.RWCTokenResponseHeader, rwcToken);
        }
        const serializedRequest: string = JSON.stringify(AddMembersRequest);
        request.onreadystatechange = function () {
            if (request.readyState === HttpReadyState.Done) {
                resolve(
                    parseResponseText(request.status === HttpStatusCode.OK, request.responseText)
                );
            }
        };
        request.ontimeout = function () {
            reject(new Error('Request timed out'));
        };
        request.send(serializedRequest);
    });
}

function parseResponseText(isSuccess: boolean, responseText: string): AddMembersRestResponse {
    try {
        const response =
            responseText && responseText.length > 0 ? JSON.parse(responseText) : undefined;

        if (isSuccess) {
            return {
                Success: true,
                SuccessMemberCount: response.SuccessMemberCount,
            };
        } else {
            const errorMessage = response?.error?.message
                ? response.error.message
                : 'Response is empty';
            return {
                Success: false,
                ErrorMessage: errorMessage,
            };
        }
    } catch (error) {
        const errorMessage = error.message;
        return {
            Success: false,
            ErrorMessage: errorMessage,
        };
    }
}
